import { inject, Injectable } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/fin-ui';

import { WalletDetailsDialogData } from '@kr/models';

import { WalletDetailsComponent } from './wallet-details.component';

@Injectable()
export class WalletDetailsDialog {
  readonly #dialog = inject(DialogService);

  open(walletDetailsData: WalletDetailsDialogData): DialogRef {
    return this.#dialog.open(WalletDetailsComponent, walletDetailsData);
  }
}
